export default __webpack_public_path__ + "static/media/jcb.8015f0fd.png";